function z(h, u) {
  const q = y(u), x = q[0], i = q[1], r = q[2], M = q[3], t = h[0], s = h[1], n = h[2], o = 2 * (r * n - M * s), c = 2 * (M * t - i * n), a = 2 * (i * s - r * t);
  return [
    t + x * o + r * a - M * c,
    s + x * c + M * o - i * a,
    n + x * a + i * c - r * o
  ];
}
function y(h) {
  const u = h[0], q = h[1], x = h[2], i = u * 0.5, r = q * 0.5, M = x * 0.5, t = Math.cos(i), s = Math.cos(r), n = Math.cos(M), o = Math.sin(i), c = Math.sin(r), a = Math.sin(M);
  return [
    t * s * n - o * c * a,
    s * n * o + t * c * a,
    t * n * c - s * o * a,
    t * s * a + n * o * c
  ];
}
export {
  z as rotateRawVector
};
//# sourceMappingURL=index22.js.map
